/* eslint-disable import/no-cycle */
import { Stack, HStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import InputPreview from '../formInputs/InputPreview';
import { FormBuilderComponentProps } from '../types';

function TimeFieldComponent({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        {labelRightRenderer}
      </HStack>
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.time')} isAdvanced={isAdvanced || false} />
      <InputPreview value="HH:MM AM" fieldId={fieldId} />
    </Stack>
  );
}

export const TimeField = React.memo(
  TimeFieldComponent,
  (prev, next) =>
    // eslint-disable-next-line
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
